/**
 * @generated SignedSource<<fe7c174a30f330e5dd3ada4b22d69f4a>>
 * @relayHash 241cb10da29957359595c449811d3876
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a94a7ab5be96477770a5a137999c8ccb5ca8fea475b2b26730b0fe6bdf5e0e00

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type jiraCreateWithRovoPreviewCardQuery$variables = {
  cloudId: string;
  projectIdOrKey: string;
};
export type jiraCreateWithRovoPreviewCardQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly " $fragmentSpreads": FragmentRefs<"footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project" | "jiraMultiWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraMultiWorkItemPreviewCard">;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudUrl: AGG$URL | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query" | "jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard" | "useAiCreateProjectContextQuery">;
};
export type jiraCreateWithRovoPreviewCardQuery = {
  response: jiraCreateWithRovoPreviewCardQuery$data;
  variables: jiraCreateWithRovoPreviewCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdOrKey"
  }
],
v1 = {
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "cloudIds.0",
          "variableName": "cloudId"
        }
      ],
      "kind": "ListValue",
      "name": "cloudIds"
    }
  ],
  "concreteType": "TenantContext",
  "kind": "LinkedField",
  "name": "tenantContexts",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "cloudUrl"
    }
  ]
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v7 = {
  "kind": "ScalarField",
  "name": "isEditable"
},
v8 = {
  "kind": "ScalarField",
  "name": "isRequired"
},
v9 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/)
  ]
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "concreteType": "JiraComponentConnection",
  "kind": "LinkedField",
  "name": "components",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraComponentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraComponent",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "componentId"
            },
            (v4/*: any*/),
            (v11/*: any*/)
          ]
        }
      ]
    }
  ]
},
v13 = [
  (v5/*: any*/),
  (v11/*: any*/),
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  {
    "kind": "ScalarField",
    "name": "picture"
  }
],
v14 = {
  "concreteType": "JiraUserConnection",
  "kind": "LinkedField",
  "name": "selectedUsersConnection",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v13/*: any*/)
        }
      ]
    }
  ]
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "priorityId"
  },
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "iconUrl"
  },
  (v11/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "value"
},
v17 = [
  (v16/*: any*/),
  {
    "concreteType": "JiraColor",
    "kind": "LinkedField",
    "name": "color",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorKey"
      },
      (v11/*: any*/)
    ]
  },
  (v11/*: any*/)
],
v18 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v7/*: any*/)
  ]
},
v19 = [
  (v16/*: any*/),
  (v11/*: any*/)
],
v20 = [
  {
    "concreteType": "JiraOptionEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v19/*: any*/)
      }
    ]
  }
],
v21 = {
  "concreteType": "JiraOptionConnection",
  "kind": "LinkedField",
  "name": "fieldOptions",
  "plural": false,
  "selections": (v20/*: any*/)
},
v22 = {
  "concreteType": "JiraOptionConnection",
  "kind": "LinkedField",
  "name": "selectedOptions",
  "plural": false,
  "selections": (v20/*: any*/)
},
v23 = [
  {
    "kind": "ScalarField",
    "name": "optionId"
  },
  (v16/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "jiraCreateWithRovoPreviewCardQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "useAiCreateProjectContextQuery"
      },
      {
        "kind": "FragmentSpread",
        "name": "jiraSingleWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraSingleWorkItemPreviewCard"
      },
      {
        "kind": "FragmentSpread",
        "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query"
      },
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "jiraMultiWorkItemCard_AtlassianConversationAssistantPreviewCard_JiraMultiWorkItemPreviewCard"
          },
          {
            "kind": "FragmentSpread",
            "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "jiraCreateWithRovoPreviewCardQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "projectId"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "issueTypeId"
                      },
                      (v4/*: any*/),
                      {
                        "concreteType": "JiraIssueTypeHierarchyLevel",
                        "kind": "LinkedField",
                        "name": "hierarchy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "level"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "small"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsConfiguration",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v6/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "JiraIssueFieldConfiguration",
                                    "abstractKey": "__isJiraIssueFieldConfiguration"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/)
                                    ],
                                    "type": "JiraComponentsField"
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/),
                      {
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsConfiguration",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueField"
                                  },
                                  (v4/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraFieldConfig",
                                        "kind": "LinkedField",
                                        "name": "fieldConfig",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraIssueFieldConfiguration",
                                    "abstractKey": "__isJiraIssueFieldConfiguration"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "text"
                                      }
                                    ],
                                    "type": "JiraSingleLineTextField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "concreteType": "JiraRichText",
                                        "kind": "LinkedField",
                                        "name": "richText",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "adfValue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAdfToConvertedPlainText",
                                                "kind": "LinkedField",
                                                "name": "convertedPlainText",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "plainText"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraRichTextField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v13/*: any*/)
                                      }
                                    ],
                                    "type": "JiraSingleSelectUserPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "type": "JiraMultipleSelectUserPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isMulti"
                                      },
                                      (v9/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "type": "JiraPeopleField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraFieldConfig",
                                        "kind": "LinkedField",
                                        "name": "fieldConfig",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": (v15/*: any*/)
                                      },
                                      {
                                        "concreteType": "JiraPriorityConnection",
                                        "kind": "LinkedField",
                                        "name": "priorities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriorityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraPriority",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v15/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraPriorityField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "concreteType": "JiraOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldOptions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v17/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "fieldOption",
                                        "plural": false,
                                        "selections": (v17/*: any*/)
                                      }
                                    ],
                                    "type": "JiraSingleSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "date"
                                      }
                                    ],
                                    "type": "JiraDatePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "dateTime"
                                      }
                                    ],
                                    "type": "JiraDateTimePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "number"
                                      },
                                      {
                                        "concreteType": "JiraNumberFieldFormatConfig",
                                        "kind": "LinkedField",
                                        "name": "formatConfig",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatStyle"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatUnit"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraNumberField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "workingHoursPerDay"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "workingDaysPerWeek"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "defaultFormat"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "defaultUnit"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraTimeTrackingField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v18/*: any*/),
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "selectedOption",
                                        "plural": false,
                                        "selections": (v19/*: any*/)
                                      },
                                      (v21/*: any*/)
                                    ],
                                    "type": "JiraRadioSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v21/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "type": "JiraMultipleSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "concreteType": "JiraCascadingOptionsConnection",
                                        "kind": "LinkedField",
                                        "name": "cascadingOptions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraCascadingOptionsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraCascadingOptions",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": (v23/*: any*/)
                                                  },
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValues",
                                                    "plural": true,
                                                    "selections": (v23/*: any*/)
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraCascadingSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v22/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "type": "JiraCheckboxesField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "uri"
                                      }
                                    ],
                                    "type": "JiraUrlField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "type": "JiraComponentsField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "JiraSprintField"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v11/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "xsmall"
              }
            ]
          }
        ]
      },
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "jira_isBetaAiFeaturesEnabled"
      }
    ]
  },
  "params": {
    "id": "a94a7ab5be96477770a5a137999c8ccb5ca8fea475b2b26730b0fe6bdf5e0e00",
    "metadata": {},
    "name": "jiraCreateWithRovoPreviewCardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "551097551ac6348fb0c743834d9a0244";

export default node;
